exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".DivEditable_todoContent__2631X{width:90%}.DivEditable_todoContent__2631X:focus{outline:none}[dir] .DivEditable_todoContent__2631X:focus{border:none}.DivEditable_textUnderLine__3kTPR{text-decoration:line-through;color:#cacaca}", ""]);

// Exports
exports.locals = {
	"todoContent": "DivEditable_todoContent__2631X",
	"textUnderLine": "DivEditable_textUnderLine__3kTPR"
};